import { Box, Button, TextField, Typography, Snackbar, Alert } from "@mui/material";
import Header from "../components/header";
import { BorderColor, HelpOutlineOutlined } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import CustomAxios from "../utils/CustomAxios";
import Sidebar from "../components/sidebar";
import { InputText } from "primereact/inputtext";
import { useMediaQuery } from 'react-responsive';

const Contact = () => {
    const [subject, setSubject] = useState("")
    const [message, setMessage] = useState("")
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' })
    const formRef = useRef(null);
    const isMobile = useMediaQuery({ maxWidth: 600 })
    
    const userdetails =JSON.parse(window.sessionStorage.getItem('details'))
    const showToast = (message, severity = 'success') => setToast({ open: true, message, severity })

    async function handlesubmit(event) {
        event.preventDefault()
        try {
            await CustomAxios.post("oasis/contact_us/", {
                name: userdetails.membername,
                email: userdetails.email,
                memberid: userdetails.memberid,
                subject: subject,
                message: message
            })

            formRef.current.reset()
            setSubject('')
            setMessage('')
            showToast('Your email has been sent successfully.', 'success')
        } catch (error) {
            showToast(error?.response?.data?.error || error?.response?.data?.data?.message || 'Failed to send. Please try again.', 'error')
        }
    }
    return (
        <Box sx={{ width: "100%" }}>
            <Header title="Koperasi" color={true}/>
            <Box sx={{ display: { xs: "block", md: "flex" } }} >
                {!isMobile&&<Sidebar color={true} />}
                <Box sx={{ display: "flex", flexDirection: "column", overflow: "auto" }}>
                    <Box sx={{ padding:"27px", width: "100%" }}>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }} >
                            <HelpOutlineOutlined sx={{ width: "40px", height: "40px", color: "#288d2c" }} />
                            <Box className="fn-h2 fw-500" sx={{ pl: 1 }}>Help</Box>
                        </Box>
                        <Box sx={{ mb: 3 }}>
                            <Typography sx={{ color: "var(--Pallate-green-500, #288d2c)", fontFamily: "inter", fontSize: "24px", fontStyle: "normal", fontWeight: "500", lineHeight: "32px" }}> Need help? We're here for you.</Typography>
                            <Typography sx={{ maxWidth: "672px", width: "100%", color: "var(--Light-Text-Default-Text, #1E293B)", fontFamily: "inter", fontSize: "18px", fontStyle: "normal", fontWeight: "400", lineHeight: "28px" }}> We're ready to help you with any questions or issues you're having. Just submit your query below and we'll get back to you as soon as possible.</Typography>
                        </Box>
                        <form ref={formRef} style={{ maxWidth: "672px", width: "100%", marginTop: "20px", gap: "40px", display: "flex", flexDirection: "column" }}>
                            <Box sx={{ display: "flex", maxWidth: "669px", width: "100%", flexDirection: "column", alignItems: "flexstart", gap: "8px" }}>
                                <Typography sx={{ alignSelf: "stretch", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px" }}>Subject Line</Typography>
                                <InputText
                                    placeholder="Max 100 Characters is allowed"
                                    style={{ width: "100%", padding: "12px", borderRadius: "4px", border: "1px solid var(--Light-Forms-Border, #CBD5E1)", background: " var(--Light-Forms-Background, #FFF)" }}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </Box> 
                            <Box sx={{display:"flex",flexDirection:"column",gap:"8px"}}>
                            <Box sx={{ display: "flex", maxWidth: "669px", height: "242px", width: "100%", flexDirection: "column", alignItems: "flexstart", gap: "8px",'&.Mui-focused': {borderColor:"green"}}}>
                                <Typography sx={{ alignSelf: "stretch", color: "var(--Light-Text-Default-Text, #1E293B)", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px" }}>Message for us</Typography>
                                <Box sx={{ display: "flex", padding: "12px", alignItems: "flex-start", flex: "1 0 0", alignSelf: "stretch", borderRadius: "4px", border: "1px solid var(--Light-Forms-Border, #CBD5E1)", background: " var(--Light-Forms-Background, #FFF)" }}>
                                <textarea
                                    maxlength="500"
                                    placeholder="Max 500 Characters is allowed"
                                    style={{ outline:"none",border:"none",display: "flex",alignItems: "flex-start", flex: "1 0 0", alignSelf: "stretch", borderRadius: "4px", background: " var(--Light-Forms-Background, #FFF)",resize:"none",color:"var(--Light-Text-Secondary-Text, #64748B)"}}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                                </Box>
                            </Box>
                                {message.length==500 && <Typography sx={{ alignSelf: "stretch",color: "#EF4444" , fontFamily: "inter", fontSize: "12px", fontStyle: "normal", fontWeight: "400", lineHeight: "16px" }}>Oops! Looks like you've exceeded the character limit. Please shorten your entry.<span style={{ color: "var(--Light-Text-Default-Text, #1E293B)" }}>Max 500 Characters is allowed</span></Typography>}
                            </Box>
                            <Button disabled={message.length==0||subject.length==0} type="submit" variant="contained" sx={{ display: "flex", width: "104px", padding: "12px", justifyContent: "center", gap: "8px", borderRadius: "4px", background: "var(--Light-Utility-Primary, #288d2c)" }} onClick={(event) => handlesubmit(event)}>
                                Submit
                            </Button>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Snackbar
                open={toast.open}
                autoHideDuration={5000}
                onClose={() => setToast(t => ({ ...t, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setToast(t => ({ ...t, open: false }))}
                    severity={toast.severity}
                    sx={{ width: '100%' }}
                >
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>
    )
}

export default Contact;